<template>
    <div class="forms-feature__contact-areas">
        <div class="forms-feature__contact-area"
             v-for="area in options"
             :key="area.name"
             :class="{ 'forms-feature__contact-area--selected': innerValue && area.name == innerValue.name}"
             @click="selectArea(area)">
            {{area.name}}
        </div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            event: 'change'
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            value: {
                default: null
            }
        },
        data() {
            return {
                innerValue: null
            }
        },
        methods: {
            selectArea(area) {
                this.innerValue = area;
            }
        },
        watch: {
            value:
            {
                immediate: true,
                handler(newValue) {
                    this.innerValue = newValue;
                }
            },
            innerValue(newValue) {
                this.$emit('change', newValue);
            }
        }
    };
</script>